<!-- Shows the certificates avaiable to a given product. Meaning you should be able to view all the certificates issued to you under a given product(crop)-->
<template>
    <div id="registerCertifier" class="flex justify-center">
        <div class="w-full self-center max-w max-w-md">
            <form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                <div class="mb-4">
                    <vue-multiselect
                        placeholder="Enter certifier name or the NOP ID for the certifier you are trying to register as."
                        :options="certifierList"
                        label="label"
                        :searchable="true"
                        @search-change="searchCertifiers"
                        @select="onCertifierChange"
                        :internalSearch="false"
                        v-model="formData.certifierSelect"
                    >
                    </vue-multiselect>
                </div>

                <div class="flex justify-center" v-if="certifierDetails.CertifierNOPID">
                    <table class="certifierDetailsTable">
                        <tr>
                            <th>
                                NOP Code
                            </th>
                            <td>{{ certifierDetails.CertifierNOPID }}</td>
                        </tr>

                        <tr>
                            <th>
                                Name
                            </th>
                            <td>{{ certifierDetails.CertifierName }}</td>
                        </tr>

                        <tr>
                            <th>
                                Website
                            </th>
                            <td>{{ certifierDetails.Website }}</td>
                        </tr>

                        <tr>
                            <th>
                                Email
                            </th>
                            <td>{{ certifierDetails.Email }}</td>
                        </tr>

                        <tr>
                            <th>
                                Phone number
                            </th>
                            <td>{{ certifierDetails.PhoneNumber }}</td>
                        </tr>

                        <tr>
                            <th>
                                Address
                            </th>
                            <td>{{ certifierDetails.HQAddress }}</td>
                        </tr>

                        <tr>
                            <th>
                                Accredited scopes
                            </th>
                            <td>{{ certifierDetails.AccridiatedScopes }}</td>
                        </tr>

                        <tr>
                            <th>
                                NOP Certificate and Accreditation Documents:
                            </th>
                            <td>
                                <a :href="certifierDetails.AccAndAuditDocURL" target="_blank" rel="noopener noreferrer">
                                    Download
                                </a>
                            </td>
                        </tr>
                    </table>
                </div>

                <div class="flex justify-center pt-5">
                    <button @click="submitCertifierToDB" class="" type="button">
                        Register account
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import asyncRequest from "./../../utils/asyncRequest.js";

export default {
    name: "LoginView",
    created() {},
    data() {
        return {
            certifierList: [],
            certifierDetails: {},
            formData: {
                certifierSelect: ""
            }
        };
    },
    methods: {
        submitCertifierToDB() {
            var URL = this.$store.state.urls.POST_ADD_NEW_CERTIFIER;

            asyncRequest.ServerAPI({
                progressBarObj: this.$Progress,
                method: "POST",
                api: URL,
                postData: { UserEmail: this.certifierDetails.Email },
                onSuccessCallback: function() {},
                flags: asyncRequest.M_FAIL | asyncRequest.M_SUCCESS,
                beforeAfterCallback: false
            });
        },
        onCertifierChange(changedVal, a, b) {
            if (!changedVal || !changedVal.value) {
                this.certifierDetails = {};
                return;
            }
            this.certifierDetails = changedVal;
        },
        searchCertifiers(searchQry) {
            if (!searchQry) {
                return;
            }

            var URL = this.$store.state.urls.GET_CERTIFIER_BY_NAME_OR_NOP_ID + searchQry + "/";

            asyncRequest.ServerAPI({
                progressBarObj: this.$Progress,
                method: "GET",
                api: URL,
                onSuccessCallback: dataIn => {
                    this.reorganizeCertifierData(dataIn);
                },
                flags: asyncRequest.M_FAIL,
                beforeAfterCallback: false
            });
        },
        reorganizeCertifierData(dataIn) {
            if (!Array.isArray(dataIn.Data)) {
                this.certifierList = [];
                return;
            }
            this.certifierList = [];
            var d = dataIn.Data;
            for (var i = 0; i < d.length; i++) {
                var l = d[i].CertifierNOPID + " : " + d[i].CertifierName;
                l += " (" + d[i].HQCountry + ") ";

                d[i].value = d[i];
                d[i].label = l;
                this.certifierList.push(d[i]);
            }
        }
    },
    components: {}
};
</script>

<style scoped>
/* We need to do some css to makesure this page is drawn over everything and takes the whole screen space */
#registerCertifier {
    height: 100%;
    width: 100%;
    background-color: #000;
    position: fixed;
    top: 0;
    z-index: 999;
}

td,
th {
    font-size: 14px;
    padding-bottom: 10px;
}
</style>
